import { render } from "./EventCard.vue?vue&type=template&id=fa598478&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=fa598478&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fa598478"

export default script